export default class WipeAnimation {
  
  startTime = 0;
  endTime = 0;
  direction = 'in';
  object = null;

  constructor({ startTime, endTime, direction }, object) {
    this.startTime = startTime * 1000;
    this.endTime = endTime * 1000;
    this.direction = direction;
    this.object = object;
  }

  _in(time) {
    const duration = this.endTime - this.startTime;
    let width = 0;

    if (this.startTime <= time && time <= this.endTime) {
      const currentTime = time - this.startTime;

      width += this.object.width * (currentTime / duration);

      const clipPath = new window.fabric.Rect({
        width,
        height: this.object.height,
        left: -(this.object.width / 2),
        top: -(this.object.height / 2)
      })

      this.object.set({ clipPath });
    }
  }

  _out(time) {
    const duration = this.endTime - this.startTime;
    let left = -(this.object.width / 2);

    if (this.startTime <= time && time <= this.endTime) {
      const currentTime = time - this.startTime;

      left -= (left * 2) * (currentTime / duration)

      const clipPath = new window.fabric.Rect({
        width: this.object.width,
        height: this.object.height,
        left: left,
        top: -(this.object.height / 2)
      })

      this.object.set({ clipPath });
    }
  }

  render(time) {
    if (!this.object) return;

    this[`_${this.direction}`](time);
  }


}